import { DELETE, GET, getUrl, POST } from 'src/services/ApiService';

const AsioSelfService = () => {
  const apiUrl = () => getUrl('home', '/partner');
  const apiCompanyUrl = () => getUrl('home', '/company');
  const asioProvisioningUrl = () => getUrl('home', '/asioselfservice');

  const getPartnerRegion = async () => {
    return await GET(`${apiUrl()}/region`, true, '1.0');
  };

  const getCheckPartner = async () => {
    return await GET(`${apiCompanyUrl()}/checkPartner`, true, '1.0');
  };

  const checkEligibility = async () => {
    return await GET(`${asioProvisioningUrl()}/checkEligibility`, true, '1.0');
  };

  const provisionAsio = async provisioningDetails => {
    return await POST(
      `${asioProvisioningUrl()}/provisioning`,
      provisioningDetails
    );
  };

  const submitFeedback = async feedbackData => {
    return await POST(`${asioProvisioningUrl()}/createcase`, feedbackData);
  };

  const getWhatsNextData = async () => {
    return await GET(`${asioProvisioningUrl()}/whatsnext`, true, '1.0');
  };

  const getVideoTutorialsData = async () => {
    return await GET(`${asioProvisioningUrl()}/videotutorials`, true, '1.0');
  };

  const hasPsaPoweredByAsioEntitlement = async () => {
    return await GET(`${asioProvisioningUrl()}/isFallUnderMonthlyCohort`, true, '1.0');
  };

  const provisionPsaPackage = async (provisioningData, instanceId) => {
    return await POST(
      `${asioProvisioningUrl()}/psaPackageProvision?instanceId=${instanceId}`,
      provisioningData
    );
  };

  const checkSubDomainStatus = async subDomain => {
    return await GET(`${asioProvisioningUrl()}/isSubDomainAvailable/${subDomain}`, true, '1.0');
  };

  const provisionAutomatePackage = async provisioningDetails => {
    return await POST(`${asioProvisioningUrl()}/automateInAsio`, provisioningDetails);
  };

  const deleteAsio = async () => {
    return await DELETE(`${asioProvisioningUrl()}/deleteAsio`);
  };

  const validateSignupData = async provisioningData => {
    return await POST(`${asioProvisioningUrl()}/validate`, provisioningData);
  };

  return {
    getPartnerRegion,
    getCheckPartner,
    provisionAsio,
    submitFeedback,
    getWhatsNextData,
    getVideoTutorialsData,
    hasPsaPoweredByAsioEntitlement,
    provisionPsaPackage,
    checkSubDomainStatus,
    checkEligibility,
    provisionAutomatePackage,
    deleteAsio,
    validateSignupData
  };
};

export default AsioSelfService();
